import { Box, Button, Grid, TextField } from '@mui/material';
import React from 'react';
import { TextInput } from 'components';
import { CATEGORIES } from 'lib/constants';

const CostItemForm = ({ costItem, handleChange }) => (
	<Grid container spacing={1}>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={costItem.name}
				label="Name"
				name="name"
				placeholder="Name"
				handleChange={handleChange}
			/>
		</Grid>

		<Grid item xs={12} sm={12}>
			<TextInput
				value={costItem.cost}
				label="Coins"
				name="cost"
				placeholder="Coins"
				handleChange={handleChange}
				type="number"
			/>
			<TextInput
				value={costItem.item}
				label="Type"
				name="item"
				placeholder="Type"
				handleChange={handleChange}
				type="text"
				disabled={true}
			/>
		</Grid>
	</Grid>
);

export default CostItemForm;
